const firebaseConfig = {
  apiKey: "AIzaSyAh-0yo7957-6TOr5EyJZZqvGF3VP3HsSQ",
  authDomain: "krypto-7c0f8.firebaseapp.com",
  projectId: "krypto-7c0f8",
  storageBucket: "krypto-7c0f8.appspot.com",
  messagingSenderId: "627629707357",
  appId: "1:627629707357:web:1cae241f420c617d6b7db4"
};

  export default firebaseConfig;